module.exports = __webpack_public_path__ + "img/喝水.28aa9be7.png";